import { render, staticRenderFns } from "./EmptyStateNoResults.vue?vue&type=template&id=f8b3c696&scoped=true"
import script from "./EmptyStateNoResults.vue?vue&type=script&lang=js"
export * from "./EmptyStateNoResults.vue?vue&type=script&lang=js"
import style0 from "./EmptyStateNoResults.vue?vue&type=style&index=0&id=f8b3c696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b3c696",
  null
  
)

export default component.exports